<template>
<div class="MeVaBe">
    <div v-if="ValueMb">
      <div v-for="(item,i) in imgsrc" :key="i">
           <div class="post-container margintop">                
            <div :class="useWeb == 'web'?'post-thumb-web':'post-thumb'"   v-on:click="showImage(item)" style="cursor:pointer;">
                <img style="width:100%" :src="item.img"/>
                </div>
            <div :class="useWeb == 'web'?'post-content-web' : 'post-content'">
                <h3 v-if="useWeb == 'web'" class="post-title">{{item.title}}</h3>
                <p v-else class="post-title" style="font-size:100% !important">{{item.title}}</p>
                <div class="gia">{{item.price}}</div>
                <div class="sale">{{item.sale}}</div>
                <div class="lien-he" v-on:click="ShowMessager(i)">Liên hệ </div>
            </div>
            </div>
            
            </div>
      </div>
      <transition v-if="showModal" name="modal">
        <div class="modal-mask">
          <div class="modal-wrapper">
            <div class="modal-container">

              <div class="modal-header">
                <slot name="header" >
                 <span style="font-weight: bold !important;"> {{modalTitle}} </span>
                </slot>
              </div>

              <div class="modal-body">
                <slot name="body">
                  <img style="width:100%" :src="modalImage" />
                </slot>
              </div>
              <div class="modal-body">
                <slot name="body">
                  <span class="gia">{{modalPrice}}</span>
                  <br>
                  <span class="sale">{{modalSale}}</span>
                </slot>
              </div>

              <div class="modal-footer">
                <slot name="footer">
                  <button class="btn btn-danger" @click="closeImage()">
                    Đóng
                  </button>
                </slot>
              </div>
            </div>
          </div>
        </div>
      </transition>
      <MessagerModalMB 
        :showModalMessager="showModalMessager"
        @closeMessager="CloseMessager"
        @moveToPage="MoveToPage"
     />
</div>
</template>


<script>
import MessagerModalMB from "@/components/MessagerModal/MessagerModal.vue"
export default {
    name: 'MeVaBe',
    components:{
        MessagerModalMB,

    },
    props:{
        ValueMb : false,
    },
    data(){ 
        return{
            useWeb: "web",
            showModal: false,
            showModalMessager: false,
            imgsrc: [
                    {img:"https://i.pinimg.com/originals/b5/27/e4/b527e4635b244834fd000ef9d3233e74.jpg",title:"Sữa MEJI hộp 1-3",price:"Giá: 400.000 VNĐ",sale:"Sale: 350.000 VNĐ"},
                    {img:"https://i.pinimg.com/originals/4e/33/8b/4e338b457d7334f9173df1b81ec3c077.jpg",title:"Sữa MEJI thanh 1-3",price:"Giá: 400.000 VNĐ",sale:"Sale: 350.000 VNĐ"},
                    {img:"https://i.pinimg.com/originals/f8/33/1e/f8331e44fad7c258c43c069abfc07b70.jpg",title:"Sữa MEJI hộp 0-1",price:"Giá: 350.000 VNĐ",sale:"Sale: 280.000 VNĐ"},
                    {img:"https://i.pinimg.com/originals/7f/65/66/7f656697d7ce2c6ca6d6f8c63c039b85.jpg",title:"Sữa MEJI thanh 0-1",price:"Giá: 350.000 VNĐ",sale:"Sale: 290.000 VNĐ"},
                   ],
            modalImage: String,
            modalTitle: String,
            modalPrice: String,
            modalSale:String,

        }
    },
    methods:{
        showImage(imgModal){
            this.showModal = true;
            this.modalImage = imgModal.img;
            this.modalTitle = imgModal.title;
            this.modalPrice = imgModal.price;
            this.modalSale = imgModal.sale;
        },
        closeImage(){
            this.showModal = false;
        },
        ShowMessager(value){
          console.log("index",value);
            this.showModalMessager = true;
        },
        CloseMessager(){
            this.showModalMessager = false;
        },
        MoveToPage(){
            this.showModalMessager = false;
        }
    },
    created(){
        if(this.$device.ios || this.$device.android){
            this.useWeb = "mobile";
        }
        
    },
}
</script>
<style scoped>
.post-container {
    margin: 20px 20px 0 0;  
    border: 2px solid rgb(248, 146, 205);
    overflow: auto
}
.margintop{
    margin-top:0px !important
}
.post-thumb {
    float: left;
    width: 100px !important;
    height: 100px !important;
}
.post-thumb-web{
     float: left;
    width: 200px !important;
    height: 200px !important;
}
.post-thumb img {
    display: block
}
.post-content {
    margin-left: 100px;
    text-align: left;
}
.post-content-web{
    margin-left: 100px;
    text-align: left;
    margin-top: 25px;
}
.post-title {
    font-weight: bold;
    font-size: 200%;
    text-align: left !important;
}
.lien-he{
    float:left;
    background-color:orange;
    padding:3px;
    border-radius:3px;
    color: red;
    margin-bottom: 2px;
    cursor: pointer;
}
.gia{
color:red;
text-decoration: line-through;
text-shadow: burlywood;
}
.sale{
color:red;
font-weight: bold;
}
/* image modal */
.modal-mask {
  position: fixed;
  z-index: 9998 !important;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
  transition: opacity 0.3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-container {
  width: 400px;
  margin: 0px auto;
  padding: 20px 30px;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
  font-family: Helvetica, Arial, sans-serif;
}

.modal-header h3 {
  margin-top: 0;
  color: #42b983;
}

.modal-body {
  margin: 20px 0;
}

.modal-default-button {
  float: right;
}

/*
 * The following styles are auto-applied to elements with
 * transition="modal" when their visibility is toggled
 * by Vue.js.
 *
 * You can easily play with the modal transition by editing
 * these styles.
 */

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}

</style>